import React from 'react';
import { omit } from 'lodash';

export const withStopProps = (Component, stopProps) => (props) => <Component {...omit(props, stopProps)} />;
